<template>
  <CRow>
    <CCol col="12" lg="6">
      <CCard no-header>
        <CCardBody>
            <div class="row">
              <div class="col-6">
                <CInput readonly :label="$t('expense_types.label')" type="text" v-model="expense.expense_type"></CInput>
              </div>
              <div class="col-6">
                <CInput readonly :label="$t('fields.employee')" type="text" v-model="expense.employee"></CInput>
              </div>
            </div>
            <div class="row">
              <div class="col-6">
                <CInput readonly prepend="$" :label="$t('fields.quantity')" type="text" placeholder="Ex: 10" v-model="expense.quantity"></CInput>
              </div>
              <div class="col-6">
                <CInput readonly :label="$t('fields.expense_date')" type="date" v-model="expense.expense_date"></CInput>
              </div>
            </div>
            <div class="row">
              <div class="col-6">
                <CTextarea readonly :label="$t('fields.comment')" :placeholder="$t('fields.comment_placeholder')" v-model="expense.comment"></CTextarea>
              </div>
            </div>
            <CButton v-if="permissions.expenses.edit" color="success" @click="editExpense()">
              <CIcon :content="$options.editIcon" /> {{ $t('button.edit') }}
              </CButton>
            <CButton color="primary" @click="goBack"><CIcon :content="$options.backIcon" /> {{ $t('button.back') }}</CButton>
        </CCardBody>
      </CCard>
    </CCol>
  </CRow>
</template>

<script>
import { mapState } from 'vuex';
import axios from 'axios';
import formMixin from "../../mixins/form";
import localeMixin from '../../mixins/locale'; // Order matters, mixin first then i18n.
import i18n from "../../i18n";
import { cilPencil, cilArrowLeft } from '@coreui/icons';

export default {
  name: 'Expense',
  mixins: [formMixin, localeMixin],
  editIcon: cilPencil,
  backIcon: cilArrowLeft,
  data() {
    return {
      expense: {
        expense_type: '',
        employee: '',
        quantity: 0,
        comment: '',
        expense_date: '',
      },
    }
  },
  computed: {
    ...mapState({
      permissions: state => state.permissions,
    })
  },
  mounted() {
    const id = this.$route.params.id;
    axios.get('/api/expenses/' + id + '?token=' + localStorage.getItem("api_token"))
    .then(response => {
      this.expense = response.data;
    }).catch(error => {
      console.log(error);
      this.$router.push({ path: '/login' });
    });
  },
  methods: {
    goBack() {
      this.$router.push({ name: "Expenses" });
    },
    editExpense() {
      const id = this.$route.params.id;
      this.$router.push({ name: 'EditExpense', params: {id} })
    }
  }
}


</script>
